module.exports = __webpack_public_path__ + "img/pricem.c82f715f.svg";